import { render, staticRenderFns } from "./program-record-item.vue?vue&type=template&id=303e732e&lang=pug&"
import script from "./program-record-item.vue?vue&type=script&lang=js&"
export * from "./program-record-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports